"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _layout = require("@chakra-ui/layout");

var _react = require("@chakra-ui/react");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["content", "_type", "onItemClick"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FileContextMenu = function FileContextMenu(props) {
  var bg = (0, _react.useColorModeValue)('white', 'gray.700');
  var itemBgColor = (0, _react.useColorModeValue)('blue.100', 'blue.400');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
      maxW: "3xs",
      borderWidth: "1px",
      borderRadius: "lg",
      overflow: "hidden",
      bg: bg,
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      children: props.items.map(function (_ref, key) {
        var content = _ref.content,
            _type = _ref._type,
            onItemClick = _ref.onItemClick,
            props = _objectWithoutProperties(_ref, _excluded);

        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, {
          mb: 1,
          mt: 1,
          children: [_type === 'ITEM' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
            bg: 'transparent',
            borderRadius: 0,
            isFullWidth: true,
            _focus: {
              boxShadow: 'none !important'
            },
            _hover: {
              bg: itemBgColor
            },
            fontWeight: "initial",
            fontSize: "sm",
            justifyContent: "flex-start",
            onClick: onItemClick,
            children: content
          }), _type === 'DIVIDER' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, _objectSpread({}, props))]
        }, key);
      })
    })
  });
};

var _default = FileContextMenu;
exports["default"] = _default;